export enum ReportKey {
    Delivery = 1,
    HedgeCoverage = 2,
    InventoryTransaction = 3
}
